<template>
    <div class="relative ml-auto mr-3 items-center lg:flex">
        <Menubar
            :model="menuItems"
            :pt="{
                root: { class: 'bg-white border-none focus:bg-white p-0' },
                menu: {
                    class: 'min-w-max left-auto right-0 font-inter text-xs font-semibold no-underline uppercase text-ds-primary-500 animate-fade-in',
                },
                content: { class: 'bg-white hover:bg-white border-none text-inherit hover:text-inherit' },
                menuitem: {
                    class: 'bg-white border-none focus:bg-white',
                },
                button: { class: 'focus:bg-white active:bg-white' },
                submenu: 'max-w-max animate-fade-in',
            }"
        />
    </div>
</template>

<script lang="ts" setup>
import { useCurrentUserService } from '@/services/current-user.service';
import Menubar from 'primevue/menubar';
import type { MenuItem } from 'primevue/menuitem';
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();
const currentPath = computed(() => ({
    [router.currentRoute.value.path]: 'active-menu-item',
}));

const currentUserService = useCurrentUserService();

const logoutForm = ref<HTMLFormElement>();

const menuItems = computed<MenuItem[]>(() => {
    const mfaValidated = currentUserService.currentUserMeta?.mfaValidated;

    // only show the logout option in the MFA flow
    const userMenu = {
        label: currentUserService.currentUser?.name,
        items: [
            {
                label: 'Logout',
                class: 'text-ds-red-500',
                command: () => {
                    logoutForm.value?.submit();
                    currentUserService.logout();
                },
            },
        ],
    };

    if (!mfaValidated) {
        return [userMenu];
    }

    // If MFA is validated, show all menu items
    return [
        {
            label: 'ID Verification Review',
            command: () => router.push('/id-verification-review'),
            class: currentPath.value['/id-verification-review'],
        },
        {
            label: 'Wire Requests',
            url: '/wireinstructionrequests',
            class: currentPath.value['/wireinstructionrequests'],
        },
        {
            label: 'Paused Payments',
            command: () => router.push('/payments/failedPayments'),
            class: currentPath.value['/payments/failedPayments'],
        },
        {
            label: 'Payoff verifications',
            command: () => router.push('/payoff-verifications'),
            class: currentPath.value['/payoff-verifications'],
        },
        userMenu,
    ];
});

defineSlots<{
    csrfField(): void;
    warning(): void;
    rightNavigation(): void;
}>();
</script>
